import { Map as ImmutableMap } from 'immutable';
import { TwoFactorAuthActionTypes } from '../actions/TwoFactorAuthActions';
import RequestStatusTypes from '../constants/RequestStatusTypes';

/*
This whole module is just a hack to delay refactoring how request status
state works. The problem is that there is no way to "reset" request status
state. This is especially troublesome for requests that may be fired multiple
times and selectors that are a function of this specific request state. In
this case, we want the confirmed verification code state to reset once
the 2fa flow is completed, this way the user can go through the flow a
second time with everything working as expected.
*/

const initialState = ImmutableMap();
export default (originalRequestStatusesReducer => (state = initialState, action) => {
  if (action.type === TwoFactorAuthActionTypes.CANCELLED_2FA_SETUP || action.type === TwoFactorAuthActionTypes.COMPLETED_GA_VERIFICATION || action.type === TwoFactorAuthActionTypes.COMPLETED_SMS_VERIFICATION) {
    return state.set('CONFIRMED_VERIFICATION_CODE', RequestStatusTypes.UNINITIALIZED);
  }
  return originalRequestStatusesReducer(state, action);
});